
import React, { Component } from 'react';

import Field from './Field'

import GiveUpButton from './GiveUpButton';

import './../../../../scss/App.scss';
import FooterLogo from '../../FooterLogo';

class BonusGame extends Component {
	constructor(props){
		super(props);

		this.giveUpTime = (window.config.giveUpTime * 1000);
		this.giveUpTimer = null;

		this.state = {
			fieldIsFocused : false,
			currentSet : 0,
			answerTree : [],
			revealingAnswersMode : false,
			showGiveUp : false,
			checkAnswer : null
		};

		this.handleCorrectAnswer = this.handleCorrectAnswer.bind(this);
		this.handleWrongAnswer = this.handleWrongAnswer.bind(this);
		this.handleFieldIsFocused = this.handleFieldIsFocused.bind(this);
		this.renderBonusSet = this.renderBonusSet.bind(this);
		this.handleSkipButton = this.handleSkipButton.bind(this);
		this.resetGiveUpTimer = this.resetGiveUpTimer.bind(this);
		this.updateAnswerHandler = this.updateAnswerHandler.bind(this);
	}

	componentWillMount(){
		//console.log("BonusGame :: componentDidMount - questions length", this.props.bonusQuestionSets);


		// init answerTree array to keep track of answers correct and pagination
		var answerTree = [];

		for(let i = 0; i < this.props.bonusQuestionSets.length; i ++){
			//console.log("componentDidMount loop i");

			answerTree[i] = [];

			for(let j = 0; j < this.props.bonusQuestionSets[i].answers.length; j++){
				//console.log("componentDidMount loop j");
				//totalAnswers++;
				answerTree[i][j] = 0;
			}
		}

		//console.log("BonusGame :: componentWillMount - answerTree : ", answerTree);

		this.setState({
			answerTree : answerTree
		});
	}

	componentDidMount(){

		window.TweenMax.set(this.refs.game, {"opacity":0});
		window.TweenMax.to(this.refs.game, .5, {"opacity":1, "filter":"blur(5px)"});


		if(this.props.bonusQuestionSets !== null){
			this.resetGiveUpTimer();
		}
	}

	componentWillUpdate(nextProps, nextState){
		// if round starting
		if(this.props.roundIsStarted === false && nextProps.roundIsStarted === true){
			this.resetGiveUpTimer();
		}

		// if not in revealing answers mode
		if(!this.state.revealingAnswersMode){
			if(this.state.answerTree.length > 0){
				if(nextState.answerTree !== this.state.answerTree){
					// if all answers solved, bonus round complete
					if(this.getTotalCorrect() >= this.getTotalAnswers()){
						//console.log("BonusGame :: componentWillMount ====== bonus game complete");
						this.props.handleBonusCompleted();
					}
					// if current set is completed, go to next page with at least one unanswered
					else if(this.isSetCompleted(this.state.currentSet)){
						const _this = this;

						setTimeout(function(){
							_this.setState({
								currentSet : _this.getNextOpenSet()
							});
						}, 1500);
					}
				}
			}
		}

		// if parent tells this to start revealing answers
		if(this.props.showAnswers === false && nextProps.showAnswers === true){
			//console.log("BonusGame :: componentWillUpdate - call revealNextAnswer");
			
			this.setState({
				revealingAnswersMode : true
			});

			const _this = this;
			setTimeout(function(){
				_this.revealNextAnswer()
			}, 10);
		}
	}

	componentDidUpdate(prevProps, prevState){
		//console.log("BonusGame :: componentDidUpdate");

		// blur the game area
		if(this.props.blurGame === true && prevProps.blurGame === false){
			//console.log("BonusGame :: componentDidUpdate - blurOut");
			this.blurOut();
		}

		// unblur the game area
		if(this.props.blurGame === false && prevProps.blurGame === true){
			//console.log("BonusGame :: componentDidUpdate - blurIn");
			this.blurIn();
		}
	}

	componentWillUnmount(){
		clearTimeout(this.giveUpTimer);
	}

	blurIn(){
		//console.log("BonusGame :: blurIn - this.refs.game : ", this.refs.game);
		window.TweenMax.to(this.refs.game, .5, {"filter":"blur(0px)"});
	}

	blurOut(){
		//console.log("BonusGame :: blurOut");
		window.TweenMax.to(this.refs.game, .5, {"filter":"blur(5px)"});
	}

	resetGiveUpTimer(){
		//console.log("BonusGame :: resetGiveUpTimer");

		const _this = this;

		clearTimeout(this.giveUpTimer);

		this.giveUpTimer = setTimeout(function(){
			//console.log("BonusGame :: resetGiveUpTimer - show give up button");
			_this.setState({
				showGiveUp : true
			});
		}, this.giveUpTime);
	}

	revealNextAnswer(){
		//console.log("=============== BonusGame :: revealNextAnswer");
		const _this = this;

		var unansweredFound = true;

		// if there is a open answer on this set, show it
		if(this.getNextOpenAnswer(this.state.currentSet) !== false){
			//console.log("BonusGame :: revealNextAnswer -  if");

			var newAnswerTree = [...this.state.answerTree];
			newAnswerTree[this.state.currentSet][this.getNextOpenAnswer()] = 1;
			
			this.setState({
				answerTree : newAnswerTree
			});
			
		}
		// else get next open set
		else if(this.getNextOpenSet() !== false){
			//console.log("BonusGame :: revealNextAnswer -  else if");

			const _this = this;

			// wait 2 seconds before revealing next page
			setTimeout(function(){
				_this.setState({
					currentSet : _this.getNextOpenSet()
				});

				// wait 1 sec before showing first answer on next page
				setTimeout(function(){
					_this.revealNextAnswer();
				}, 1000);
			}, 2500);

			return false;
		}
		// if no open sets, then it is done revealing all
		else{
			//console.log("BonusGame :: revealNextAnswer -  else");
			unansweredFound = false;
		}

		//

		if(unansweredFound){
			setTimeout(function(){
				_this.revealNextAnswer();
			}, 1000);
		}
		else {
			_this.props.handleAnswerRevealComplete();
		}
	}

	getTotalAnswers(){
		var count = 0;

		for(let i = 0; i < this.state.answerTree.length; i ++){
			for(let j = 0; j < this.state.answerTree[i].length; j++){
				count++;
			}
		}

		return count;
	}

	getTotalCorrect(){
		var count = 0;

		for(let i = 0; i < this.state.answerTree.length; i ++){
			for(let j = 0; j < this.state.answerTree[i].length; j++){
				count = count + this.state.answerTree[i][j];
			}
		}

		return count;
	}

	isSetCompleted(setNo){
		//console.log("BonusGame :: isSetCompleted - setNo: ", setNo);
		
		for(let i = 0; i < this.state.answerTree[setNo].length; i ++){
			if(this.state.answerTree[setNo][i] === 0){
				//console.log("BonusGame :: isSetCompleted - return false");
				return false;
			}
		}
		//console.log("BonusGame :: isSetCompleted - return true");
		return true;
	}

	isLastSet(){
		//console.log("BonusGame :: isLastSet");

		var openSets = 0;

		for(let i = 0; i < this.state.answerTree.length; i ++){
			if(!this.isSetCompleted(i)){
				openSets++;
			}
		}

		if(openSets > 1){
			return false;
		}
		else{
			return true;
		}

	}

	getLastAnswerIndex(){
		return this.state.answerTree[this.state.currentSet].length - 1;
	}

	getNextOpenSet(){
		//console.log("BonusGame :: getNextOpenSet");

		var index = this.state.currentSet;
		var count = 0;
		const totalSets = this.state.answerTree.length;

		//console.log("BonusGame :: getNextOpenSet - totalSets : " + totalSets + "    ");

		while(count < totalSets){
			count++;

			// if at last set, start back at first set
			if(index >= (totalSets - 1)){
				index = 0;
			}
			// else increment for next set
			else{
				index = index + 1;
			}

			// if the next set is not completed, return it's index
			if(!this.isSetCompleted(index)){
				return index;
			}
		}

		// if nothing found, return false
		return false;
	}

	getNextOpenAnswer(){
		//console.log("BonusGame :: getNextOpenAnswer");

		if(this.isSetCompleted(this.state.currentSet) !== true){
			//console.log("BonusGame :: getNextOpenAnswer - if");
			var ret = false;
			var count = 0;
			while(!ret || count < 10){
				if(this.state.answerTree[this.state.currentSet][count] === 0){
					/*
					var newAnswerTree = [...this.state.answerTree];
					newAnswerTree[nextOpenSet][count] = 1;

					this.setState({
						answerTree : newAnswerTree
					});
					*/

					ret = true;



					//console.log("BonusGame :: getNextOpenAnswer - return: ", count);

					return count;
				}
				else {
					count++;
				}
			}
		}
		else {
			//console.log("BonusGame :: getNextOpenAnswer - else");
			return false;
		}
	}

	updateAnswerTree(setNo, i){
		var answerTree = [...this.state.answerTree];

		answerTree[setNo][i] = 1;

		this.setState({
			answerTree : answerTree
		});
	}

	handleCorrectAnswer(setNo, i){
		//console.log("setNo: " + setNo + "    i: " + i);
		const _this = this;

		window.TweenMax.set(this.refs.correctAnswerCue, {"opacity": .8});
		window.TweenMax.to(this.refs.correctAnswerCue, 1.3, {"opacity": 0, onComplete:function(){
			
		}});

		// update completion
		_this.updateAnswerTree(setNo, i);
	}

	handleWrongAnswer(){
		//console.log("Game:: show wrong answer cue");

		window.TweenMax.set(this.refs.wrongAnswerCue, {"opacity": .8});
		window.TweenMax.to(this.refs.wrongAnswerCue, 1.3, {"opacity": 0});
	}

	handleFieldIsFocused(boolean){
		this.setState({
			fieldIsFocused : boolean
		});
	}

	handleSkipButton(){
		//console.log("BonusGame :: handleSkipButton");
		window.sounds.startButtonClick.play();

		this.resetGiveUpTimer();

		const nextSet = this.getNextOpenSet();
		//console.log("BonusGame :: handleSkipButton - nextSet : ", nextSet);

		if(nextSet !== false){
			this.setState({
				currentSet : nextSet
			});
		}
	}

	updateAnswerHandler(answer){
		//console.log("BonusGame :: updateAnswerHandler - answer ", answer);
		this.setState({
			checkAnswer : answer
		});
	}

	renderInstructionsHint(){
		if(!this.state.revealingAnswersMode){
			if(this.state.fieldIsFocused){
				return(
					<div className="hint">(fill-out the answer)</div>
				)
			}
			else{
				return(
					<div className="hint">(choose a blanked-out word to start typing)</div>
				)
			}
		}
	}

	renderAnswers(answersArray, setNo){
		//console.log("GamePage:: renderAnswers");

		const _this = this;

		return answersArray.map(function(answer, i){
			//console.log("Bonusgame :: renderAnswers - _this.state.answerTree[setNo][i]", _this.state.answerTree[setNo][i]);
			const shouldShowAnswer = (_this.state.answerTree[setNo][i] === 1) ? true : false;
			return <Field key={i} answer={answer} handleCorrectAnswer={() => _this.handleCorrectAnswer(setNo, i)} handleWrongAnswer={_this.handleWrongAnswer} handleFieldIsFocused={_this.handleFieldIsFocused} showAnswers={shouldShowAnswer} checkAnswer={_this.state.checkAnswer} updateAnswerHandler={_this.updateAnswerHandler} revealingAnswersMode={_this.state.revealingAnswersMode} bonusSet={setNo} currentSet={_this.state.currentSet} />;
		});
	}

	renderBonusSet(questionSet, i){
		const _this = this;

		let isShowing = (this.state.currentSet === i) ? " show" : "";

		const answersReadOnly = (this.props.showAnswers) ? " readOnly" : "";

		return(
			<div className={"bonusSet" + isShowing} key={i}>
				<div className="questionBox">{questionSet.question}</div>
				<div className={"answers_wrapper" + answersReadOnly} onClick={() => this.resetGiveUpTimer()}>
					{_this.renderAnswers(questionSet.answers, i)}
				</div>
			</div>
		);
	}

	renderSkipBtn(){
		//console.log("BonusGame :: renderSkipBtn - this.isLastSet : " + this.isLastSet() + "      this.state.hideSkipBtn : " + this.state.hideSkipBtn);

		if(!this.isLastSet() && !this.state.revealingAnswersMode){
			return(
				<div className="skipBtn" onClick={() => this.handleSkipButton()} onMouseOver={() => window.sounds.buttonHover.play()}>SKIP</div>
			);
		}
	}

	render(){
		return(
			<div id="bonusGame" ref="game">
				{this.props.bonusQuestionSets.map(this.renderBonusSet)}
				{this.renderInstructionsHint()}
				{this.renderSkipBtn()}
				<GiveUpButton show={(this.state.showGiveUp && this.props.roundIsStarted)} handleGiveUp={() => this.props.handleGiveUp()} onMouseOver={() => window.sounds.buttonHover.play()} />
				<div className="correctAnswerCue" ref="correctAnswerCue"></div>
				<div className="wrongAnswerCue" ref="wrongAnswerCue"></div>
				<FooterLogo />
			</div>
		);
	}

}

export default BonusGame;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/game/BonusGame.js